import { get } from 'http';
import { CONSTANTS } from './constants';

/**
 * List of rest api's
 */
export const CONFIG = {
  /**
   * /core/app
   */
  
  END_POINT_BASE_URI: '/core/ms',
  END_POINT_MS_BASE_URI: '/core/ms',
  
  // Global Module
  CHECK_USER_ACCESS: '/global/checkUserAccess',
  GET_RESOURCES: '/global/api/getResources',
  MS_GET_GLOBAL_BUNDLE: '/global/api/getLovBundle', 
  GET_LOVS: '/global/api/getLovs',
  GET_CORE_LOVS: '/global/getLovs',
  GET_HIERARCHY: '/global/api/getHierarchy',
  MS_GET_HIERARCHY: '/global/api/getHierarchy',
  GET_GLOBAL_BUNDLE: '/global/api/getBundle',
  GET_CORE_GLOBAL_BUNDLE: '/global/getBundle',
  
  GET_GLOBAL_MANAGENOTE:'/global/api/manageNote',
  MANAGE_ADDRESS: '/global/api/manageAddress',
  MANAGE_PHONE: '/global/api/managePhone',
  MANAGE_EMAIL: '/global/api/manageEmail',
  MANAGE_CONTACT: '/global/api/manageContact',
  MANAGE_NOTE: '/global/api/manageNote',
  MANAGE_CORE_NOTE: '/global/manageNote',
  DOWNLOAD_FILE: '/global/api/downloadFile',
  CORE_DOWNLOAD_FILE: '/global/downloadFile',
  VERIFY :'core/ms/auth/api/validatePlaTotac',
  GET_GLOBAL_HOMEBUNDLE: '/global/api/getHomePageBundle',
  MS_GET_GLOBAL_HOMEBUNDLE: '/global/api/getHomePageBundle',
  MANAGE_FILE_UPLOAD: '/global/api/manageFileUpload',
     
  
  // User Module
   LOGIN: '/user/login',
   MS_LOGIN:'/auth/api/gateway',
   MS_VERIFY_LINK:'/auth/api/validatePlaTotac',
   MS_GETUSERDASHBOARD:'/user/api/getUserDashboard',
   LOGOUT: '/user/logout',
   RESET_PASSWORD: '/user/api/resetPassword',
  
  CHECK_USER_NAME: '/user/checkUserName',
  MS_CHECK_USER_NAME: '/user/api/checkUserName',

  GET_USER_BUNDLE: '/user/getBundle',
  GET_MS_USER_BUNDLE:'/user/api/getBundle',
  GET_USER_DASHBOARD: '/user/getUserDashboard',
  MANAGE_USER: '/user/manageUser',
  MS_MANAGE_USER: '/user/api/manageUser',
  MANAGE_PROFILE: '/user/manageProfile',
  MS_MANAGE_PROFILE: '/user/api/manageProfile',
 
  MANAGE_USER_PROFILE: '/user/api/manageUserProfile',

  MS_MANAGE_USER_PROFILE: '/user/api/manageUserProfile',
  CLONE_USER: '/user/cloneUser',
  MS_CLONE_USER: '/user/api/cloneUser',
 MS_ADMIN_USER: '/api/getBundle',
 
 // Facility Module
  GET_FACILITY_BUNDLE: '/facility/getBundle', 
  GET_MS_FACILITY_BUNDLE: '/facility/api/getBundle',
  GET_MS_FACILITY_TYPE_MAP: '/facility/api/getFacilityTypeMap',
  GET_MS_HIERARCHY: '/global/api/getHierarchy',
  CHECK_NAME: '/facility/checkName',
  MS_CHECK_NAME: '/facility/api/checkName',
  RESET_IMS_SERVICE_KEY: '/facility/resetImsServiceKey',
  MANAGE_FACILITY: '/facility/api/manageFacility',
  MANAGE_MS_FACILITY: '/facility/api/manageFacility',
  MANAGE_INTERFACE_ENTITY: '/facility/manageInterfaceEntity',
  MANAGE_MS_INTERFACE_ENTITY: '/interfaces/api/manageInterfaceEntity',

  MANAGE_VENDOR: '/facility/manageVendor',
  MS_MANAGE_VENDOR: '/interfaces/api/manageVendor',
  MS_SEARCH_FACILITY: '/core/ms/facility',
  VALIDATE_WEBSERVICE_ACC: '/facility/validateWebSvcAcctActivationKey',
  ACTIVATE_WEBSERVICE_ACC: '/facility/updateWebSvcAccount',
  MANAGE_PROVIDER_ADDRESS: '/facility/api/manageProviderAddress',

  // VFC Module
  GET_VFC_BUNDLE: '/vfc/getBundle',
  GET_MS_VFC_BUNDLE: '/vaccFund/api/getBundle',
  MANAGE_VFC: '/vfc/manageVfc',


  // Patient Module
  GET_PATIENT_BUNDLE: '/patient/getBundle',
  GET_MS_PATIENT_BUNDLE: '/patient/api/getBundle',
  UPDATE_SEARCH_PREF: '/patient/api/updatePatientSearchPref',
  MANAGE_PATIENT: '/patient/api/managePatient',
  UPDATE_FACILITY: '/patient/api/updatePatientFacility',
  UPDATE_CONSENT: '/patient/api/updatePatientConsent',
  MANAGE_DOSE: '/patient/api/manageDose',
  MANAGE_DOSE_REFUSAL: '/patient/api/manageDoseRefusal',
  MANAGE_ADVERSE_EVENT: '/patient/api/manageAdverseEvent',
  MANAGE_FOLLOWUP: '/patient/api/manageFollowup',
  MANAGE_PATIENT_NOTE: '/patient/api/managePatientNote',
  MANAGE_LEAD_TEST: '/patient/api/manageLeadTest',
  MANAGE_IMMUNITY_TEST: '/patient/api/manageImmunityTest',
  MANAGE_PATIENT_MERGE: '/patient/api/managePatientMerge',
  GET_MERGED_PATIENT_BUNDLE: '/admin/getBundle',
  // Geo Code call for Patient
  GEO_CODE_CALL: '/ext/geocode/execute',
  // INVENTORY
  GET_CORE_INV_BUNDLE : '/inventory/getBundle',
  GET_INV_BUNDLE: '/inventory/api/getBundle',
  MANAGE_INVENTORY: '/inventory/api/manageInventory',
  MANAGE_INVENTORY_REVIEW_REJECT: '/inventory/api/manageInventoryReviewReject',
  MANAGE_INVENTORY_TXN: '/inventory/api/manageInventoryTxn',
  MANAGE_INVENTORY_TFR: '/inventory/api/manageInventoryXfer',
  MANAGE_PATIENT_ALIASES: '/patient/api/managePatientAlias',
  EXECUTE_WASTE_EXTRACT: '/inventory/api/executeWasteExtract',
  CORE_EXECUTE_WASTE_EXTRACT: '/inventory/executeWasteExtract',
  DOWNLOAD_EXTRACT: '/inventory/api/downloadWasteExtract',
  GET_AUDIT_BUNDLE: '/interfaces/audit/getBundle',
  MANAGE_PATIENT_NEXTOFKIN: '/patient/api/managePatientNextOfKin',
  AUDIT_DOWNLOAD: '/audit/download',
  SEND_EMAIL: '/global/api/sendMail',
  EHDI_BUNDLE: '/ehdi/getBundle',
  MS_EHDI_BUNDLE: '/ehdi/api/getBundle',
  EHDI_MANAGE_NBHF: '/ehdi/api/manageNbhFollowupContact',
  MANAGE_NBH_FOLLOW_UP: '/ehdi/api/manageNbhFollowup',
  MANAGE_NBH_LOSTTo_FOLLOW_UP: '/ehdi/api/manageNbhLostToFollowup',
  MANAGE_NBH_RISK_FACTOR_CODE: '/ehdi/api/manageNbhRiskFactor',
  MANAGE_NBH_FOLLOWUP_CONTACT: '/ehdi/api/manageNbhFollowupContact',
  MANAGE_VFC_VACCINE_MAP: '/imods/manageVfcVaccineMap',

  
  
  
  // imods Module
  GET_MS_IMODS_BUNDLE: '/vaccOrder/api/getBundle',
  GET_IMODS_BUNDLE : '/imods/getBundle',
  MANAGE_VACCINE: '/imods/manageVaccine',
  MANAGE_FACILITY_VACCINE_RESTRICTION: '/imods/manageFacilityVaccineRestriction',
  MANAGE_VACCINE_ORDER: '/imods/manageVaccineOrder',
  UPDATE_ORDER_RESTRICTION: '/imods/updateOrderRestriction',
  CHECK_STORAGE_UNITNAME: '/vaccOrder/api/checkStorageUnitName',
  MANAGE_STORAGE_UNIT: '/vaccOrder/api/manageStorageUnit',
  MANAGE_TEMP_LOG: '/vaccOrder/api/manageTemperatureLog',
  CLAIM_VFC_ENROLL: '/vfc/claimVfcEnrollmentForm',
  GET_ADMIN_BUNDLE: '/admin/getHomePageBundle',

  
  
  // Interface Module
  GET_INTFC_BUNDLE: '/interfaces/api/getBundle',
  GET_MS_INTERFACE_BUNDLE: '/interfaces/api/getBundle',
  MANAGE_INTERFACE_PROFILE: '/interfaces/api/manageInterfaceProfile',
  RESET_IMS_WEBSERVICE: '/interfaces/api/resetWebSvcAccountKey',
  GET_HOME_SEARCH_VENDOR : '/interfaces/api/searchVendor',

  // enrollment
  ADD_ENROLLMENT_FORM: '/interfaces/api/interfaceEnrollment',
  UPDATE_ENROLLMENT_FORM: '/interfaces/api/updateInterfaceEnrollment',
  INTFC_ADMIN_BUNDLE: '/interfaces/getHomePageBundle',
  ADMIN_BUNDLE: '/admin/getBundle',
  USER_ENROLLMENT: '/admin/userEnrollment',
  Facility_ENROLLMENT: '/admin/facilityEnrollment',
  UPDATE_USER_ENROLLMENT: '/admin/updateUserEnrollment',

  // Training
  INTFC_DOWNLOAD: '/interfaces/api/downloadInterfaceFile',
  INTFC_FILE_UPLOAD : '/interfaces/api/uploadFile',
  VFC_BULK_ACTIVATE: '/vfc/vfcBulkActivation',
  UPDATE_ORDER_SHIPMENT: '/vaccOrder/api/updateOrderShipment',
  VALIDATE_ACTIVATION_KEY: '/user/api/validateActivationKey',
  ACTIVATE_USER: '/user/api/activateUser',
  VERIFY_USER: '/user/api/verifyUser',
  FORGOT_PASSWORD: '/user/api/forgotPassword',
  RESET_USER_PASSWORD: '/user/api/resetUserPassword',
  
  MS_RESET_USER_PASSWORD: '/user/api/resetUserPassword',

  UPDATE_USER_SETUP: '/user/api/updateUserSetup',
  USER_ADMIN_BUNDLE: '/user/api/getHomePageBundle',
  //MANAGE_SESSION: '/user/manageSession',
  MS_MANAGE_SESSION: '/user/api/manageSession',
  MANAGE_VFC_THERMOMETER_FILE: '/vfc/manageVfcThermometerFile',
  GET_VFC_THERMOMETER_FILE: '/vfc/getVfcThermometerFile',
  DOWNLOAD_THERMOMETER_FILE: '/vfc/downloadThermometerFile',
  SMOKE_TEST: '/interfaces/smokeTest',
  IMS_SERVICE_TEST: '/interfaces/imsServiceTest',
  
  // Complock
  MANAGE_COMP_LOCK: '/global/manageComponentLock',
  LOG_ERROR: '/global/uiLogger',
  GLOBAL_GET_CONTACT: '/global/getContact',
  REPORTS_GENERATE: '/report/api/generate',
  HEDIS_UPLOAD: '/interfaces/api/uploadHedisFile',
  HEDIS_DOWNLOAD: '/interfaces/api/downloadHedisFile',
  ACTIVATE_CRUSH_FTP: '/facility/activateCrushFtpAccount',
  JOB_GET_BUNDLE: '/job/getBundle',
  MANAGE_REMINDER_RECALL_JOB: '/job/manageReminderRecallJob',
  REMINDER_RECALL_BULK_TASK: '/job/bulkTask',
  GET_PROPERTY: '/global/getCoreProperty',
 // GET_PROPERTY: '/job/api/getBundle',
  BULK_STUDENT_TRANSFER: '/patient/api/bulkStudentTransfer',
  EXECUTE_ICE_JOB: '/job/api/executeIceJob',
  MANAGE_DISEASE_HISTORY: '/patient/api/manageDiseaseHistory',
  MANAGE_CONTRAINDICATIONS: '/patient/api/manageContraindications',
  GET_CASA_REPORTS: '/report/getCASAReports',

  //NEW SITE AND USER ENROLLMENT WITHOUT LOGIN
  MANAGE_FACILITY_ENROLLMENT: '/facility/api/manageFacilityEnrollment',

  //MANAGE SCHOOL FORM
  MANAGE_SCHOOL_FORM: '/facility/api/manageSchoolForm',

  //MANAGE SCHOOL FORM CONTACT
  MANAGE_SCHOOL_FORM_CONTACT: '/facility/api/manageSchoolContact',

  // COVID APIS
  COVID_SEARCH_SITE_AND_USER_ENROLLMENT: CONSTANTS.COVID_BASE_URL + 'searchFacilityEnrollment',
  COVID_SEARCH_USER_ENROLLMENT_FOR_FACILITY: CONSTANTS.COVID_BASE_URL + 'searchUserEnrollment',
  COVID_UPDATE_FACILITY_ENROLLMENT: CONSTANTS.COVID_BASE_URL + 'updateFacilityEnrollment',
  COVID_UPDATE_USER_ENROLLMENT: CONSTANTS.COVID_BASE_URL + 'updateUserEnrollment',
  COVID_SEARCH_USER_ENROLLMENT: CONSTANTS.COVID_BASE_URL + 'searchUserEnrollment',

  // MANAGE USER AGREMENT
  MANAGE_USER_AGREEMENT: '/user/api/manageUserConfidentialityAgreement',

  // COVID-19
  GET_COVID_BUNDLE: '/covid/getBundle',
  GET_MS_VACCFUND_BUNDLE : '/vaccFund/api/getBundle',
  MANAGE_COVID_VACCINE_ENROLLMENT: '/covid/manageCovidVaccineEnrollment',
  MANAGE_COVID_VACCINE_ENROLLMENT_THERMOMETER_FILE: '/covid/manageCovidVaccineEnrollThermometerFile',
  DOWNLOAD_COVID_VACCINE_ENROLLMENT_THERMOMETER_FILE: '/covid/downloadCovidVaccineEnrollThermometerFile',
  CLAIM_COVID_VACC_ENROLL: '/covid/claimCovidVaccineEnrollmentForm',
  COVID_BULK_ACTIVATE: '/covid/covidVaccineEnrollBulkActivation',
  MANAGE_COVID_VACCINE_AGREEMENT_FILE: '/covid/manageCovidVaccineEnrollAgreementFile',
  DOWNLOAD_COVID_VACCINE_AGREEMENT_FILE: '/covid/downloadCovidVaccineEnrollAgreementFile',
  DOWNLOAD_COVID_REPORT: '/report/api/downloadCovidReport',
  COVID_SENDMAIL: '/covid/sendMail',

  // STATEFUND
  GET_STATE_FUND_BUNDLE: '/vaccFund/api/getBundle',
  MANAGE_STATE_FUND:'/vaccFund/api/manageVaccFund',
  EXECUTE_STATE_FUND_WASTE_EXTRACT: '/vaccFund/api/executeWasteExtract',
  DOWNLOAD_STATE_FUND_WASTE_EXTRACT: '/vaccFund/api/downloadWasteExtract',
  EXECUTE_STATE_FUND_ORDER_EXTRACT: '/vaccFund/api/executeOrderExtract',
  DOWNLOAD_STATE_FUND_ORDER_EXTRACT: '/vaccFund/api/downloadOrderExtract',

  // MONKEYPOX 
  
  MONKEYPOX_GETBUNDLE: '/monkeypox/getBundle',
  DOWNLOAD_SMALLPOX_REPORT: '/report/api/downloadCovidReport',
  DOWNLOAD_MONKEYPOX_REPORT: '/report/api/downloadCovidReport',
  MONKEYPOX_MANAGE_PROV_AGMT: '/monkeypox/manageProviderAgreement',

  
  
  // COVID APIS
  COVID_ADD_FACILITY_AND_USER_ENROLLMENT: CONSTANTS.COVID_BASE_URL + 'addFacilityEnrollment',
  BULK_PLACE_ORDER: '/imods/manageBulkVaccineOrderList',
  EXECUTE_COVID_WASTE_EXTRACT: '/covid/executeWasteExtract',
  DOWNLOAD_COVID_EXTRACT: '/covid/downloadWasteExtract',
  UPLOAD_KPI: '/covid/uploadKPI',
  DOWNLOAD_KPI: '/covid/downloadKPI',
  INITIATE_MVRS_REPORT: '/monkeypox/initiateMVRSReport',
  INITIATE_MVRS_REPORT_FOR_UDPATE_OR_DELETE: '/monkeypox/initiateCVRSReportForUpdateOrDelete',
  INITIATE_CVRS_REPORT: '/report/api/initiateCVRSReport',
  INITIATE_CVRS_REPORT_FOR_UDPATE_OR_DELETE: '/report/api/initiateCVRSReportForUpdateOrDelete',
  UPDATE_INV_EXPIRY: '/report/api/updateInventoryExpirationDetails',

  // IMM 48
  MANAGE_IMM48: '/vfc/manageImm48',
  MANAGE_STATEFUND_IMM48: '/vaccFund/imm48/manageImm48',
  MANAGE_IMM48_STATUS: '/vfc/manageImm48Status',
  MANAGE_STATEFUND_IMM48_STATUS: '/vaccFund/imm48/manageImm48Status',

  // ADMIN
  MANAGE_LOOKUP: '/admin/api/manageLookup',
  MS_ADMIN_BUNDLE: '/admin/api/getBundle',
  CREATE_NAVIGATION: '/admin/api/createWebPageNavigation',
  GET_MS_ADMIN_BUNDLE: '/admin/api/getHomePageBundle',
  MANAGE_BULLETIN_BOARD: '/admin/api/manageBulletinBoard',
  MANAGE_FAQ: '/admin/api/manageFAQ',
  MANAGE_FAQ_DISPLAY_ORDER: '/admin/api/manageFAQDisplayOrder',
  MANAGE_TRAINING_SCHEDULE: '/admin/api/manageTrainingSchedule',
  BULLETIN_BOARD_UPLOAD_FILE: '/admin/api/uploadBulletinBoardFile',
  UPDATE_PRE_REGISTRATION: '/admin/api/updateTrainingPreRegistration',
  PRE_REGISTRATION: '/admin/api/trainingPreRegistration',
};
